import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TPostWithAuthor, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Query key for fetching a specific post - non-hook version
 */
export const getPostQueryKey = (postId: string) => [ENTITY, 'posts', 'detail', postId];

/**
 * Query key for fetching a specific post
 */
export const useGetPostQueryKey = (postId: string) => getPostQueryKey(postId);

/**
 * Hook to fetch a specific post by ID
 * Used in post detail page
 *
 * @param postId - Post ID (UUID)
 */
export const useGetPost = (postId: string) => {
  return useQuery<TPostWithAuthor, TError>({
    queryKey: useGetPostQueryKey(postId),
    queryFn: async () => {
      const res = await axios.get<TPostWithAuthor>(`/community-hub/posts/${postId}`);
      return res.data;
    },
    enabled: !!postId,
    staleTime: 60 * 1000, // 1 minute
  });
};
